export const AZURE_APP_CLIENT_ID = "/carehub/auth/B2c-SPA-App-ClientID";
export const AZURE_SCOPE_URL = "/carehub/auth/Tableau-Custom-Scope";
export const AZURE_SIGNIN_POLICY = "/carehub/auth/B2c-SignIn-PolicyName";
export const AZURE_PROFILE_EDIT_POLICY =
  "/carehub/auth/B2c-EditProfile-PolicyName";
export const AZURE_SIGNIN_AUTHORITY =
  "/carehub/auth/B2c-SignIn-Authority";
export const AZURE_PROFILE_EDIT_AUTHORITY =
  "/carehub/auth/B2c-ProfileEdit-Authority";
export const AZURE_AUTHORITY_DOMAIN = "/carehub/auth/B2c-Domain";